function SkeletonCard() {
  return <div className="skeleton-card" />;
}

export default SkeletonCard;